<template>
  <div class="tw-flex tw-items-center tw-gap-4">
    <PresentingToggle />

    <NewRemarkButton
      owner-type="ClientMeeting"
      :owner-id="props.pageData.clientMeetingId"
      :hide-period-selector="true"
      :selected-tag-ids="selectedTagIds"
      :is-client-meeting-remark="true"
      modal-size="l"
    />
  </div>
</template>

<script setup lang="ts">
import type { PresentPageData } from '@app/application/client_meetings/types'

import { useTalkingPointTag } from '@app/application/client_meetings/composables/use-talking-point-tag'
import NewRemarkButton from '@app/shared/vue/components/new-remark/new-remark-button.vue'
import PresentingToggle from '@app/application/client_meetings/screens/present/components/presenting-toggle.vue'

defineOptions({ name: 'MeetingPresentationHeaderRight' })

const props = defineProps<{ pageData: PresentPageData }>()

const { talkingPointTagIds: selectedTagIds } = useTalkingPointTag()
</script>
